/* eslint-disable import/no-extraneous-dependencies */

import Admin from '../../components/Admin';

const isNotDivider = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'DIVIDER',
]);

export default [
  ['FieldRadio', {
    name: 'divider_height',
    label: null,
    initialValue: 'medium',
    choices: [
      { value: 'small', label: 'Small' },
      { value: 'medium', label: 'Medium' },
      { value: 'large', label: 'Large' },
    ],
    col: 24,
    block: true,
  }],
].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
  fieldType,
  { ...fieldConfig, skip: [isNotDivider, ...(fieldConfig.skip || [])] },
]));
